export default __webpack_public_path__ + "media/images/svg/x-icon-outline-cb0dc609af57bc470c6c41586b77bd84.svg";